import styled from "styled-components";
import { maxSize, px2vw, px2percent} from "../../Utils/common";
import { STYLE_TYPE, themeColor } from "../../Utils/magicStrings";

export const HeaderPictureWrapper = styled('div')`
    width: 100%;
    ${props => props.hasMarginTop && maxSize(36, props.styleType, 'margin-top', 50)};
    position: relative;
`;

export const Logo = styled('div')`
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    z-index: 3;
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                top: 16px;
                width: ${px2vw(50, 375)};
                height: ${px2vw(55, 375)};
            `
        } else {
            return `
                ${maxSize(props.hasMarginTop ? 18 : 50, props.styleType, 'top')};
                width: ${px2vw(62)};
                height: ${px2vw(68)};
            `
        }
    }}
    & img {
        width: 100%;
        height: 100%;
    }

`;


export const SocialMediaWrapper = styled('div')`
    position: absolute;
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                top: ${px2vw(18, 375)};
                right: ${px2vw(20, 375)};
                display: flex;
                flex-direction: column;
                align-items: center;
            `
        } else {
            return `
                display: flex;
                ${maxSize(props.hasMarginTop ? 28 : 60, props.styleType, 'top')};
                left: ${px2percent(1284, 1440)};
                transform: translate(-50%);
            `
        }
    }}
    &:first-child {
        border-left: none;
        margin-top: 0;
    }
`;

export const SocialMediaLogo = styled('div')`
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
            &#facebook {
                width: ${px2vw(20, 375)};
                height: ${px2vw(20, 375)};
            }
            &#wechat {
                width: ${px2vw(28, 375)};
                height: ${px2vw(28, 375)};
                margin-top: ${px2vw(21, 375)};
            }
            &#weibo {
                width: ${px2vw(22.67, 375)};
                height: ${px2vw(18.13, 375)};
                margin-top: ${px2vw(21, 375)};
            }
            & img {
                width: 100%;
                height: 100%;
            }

            `
        } else {
            return `
                display: flex;
                padding: 0 13px;
                align-items: center;
                &#facebook {
                    ${maxSize(28, props.styleType, 'width')};
                    ${maxSize(28, props.styleType, 'height')};

                    & img {
                        ${maxSize(20, props.styleType, 'width')};
                        ${maxSize(20, props.styleType, 'height')};
                    } 
                }
                &#wechat {
                    ${maxSize(32, props.styleType, 'width')};
                    ${maxSize(32, props.styleType, 'height')};
                   border-left: 1px solid #FFFFFF;
                   & img {
                       
                    ${maxSize(32, props.styleType, 'width')};
                    ${maxSize(32, props.styleType, 'height')};
                } 

                }
                &#weibo {
                    ${maxSize(28, props.styleType, 'width')};
                    ${maxSize(28, props.styleType, 'height')};
                    border-left: 1px solid #FFFFFF;
                & img {
                    ${maxSize(22.67, props.styleType, 'width')};
                    ${maxSize(22.13, props.styleType, 'height')};
                } 

                }   
                
            `
        }
    }}
`;

const getMenuLeft = () => {
    let left = '';
    if(window.innerWidth > 1440) {
        left = (window.innerWidth - 1440) / 2 + 38;
        return `${px2vw(left, 1440)}`;
    } else {
        return `${px2vw(38, 1440)}`
    }
};

export const MenuWrapper = styled('div')`
    position: fixed;
    ${props => maxSize(60, props.styleType, 'top', props.hasMarginTop ? 74 : 30)};
    left: ${getMenuLeft()};
    z-index: 2;
    display: flex;
    align-items: center;
    z-index: 10;
`;

export const MenuLine = styled('div')`
    ${props => maxSize(36, props.styleType, 'width')};
    ${props => maxSize(3, props.styleType, 'margin-top',0.1)};

    margin-right: 10px;
    & :first-child {
        margin-top: 0;
    }
    & div{
        width: 100%;
        height: 1px;
        margin-top: 5px;
        background-color: ${props => props.color};
    }
`;

export const MenuWord = styled('div')`
    ${props => maxSize(16, props.styleType, 'font-size')};
    ${props => maxSize(5, props.styleType, 'margin-top')};
    letter-spacing: 0.2em;
    color: ${props => props.color};
`;

export const MenuWindowWrapper = styled('div')`
    ${props => maxSize(720, props.styleType, 'width', 280)};
    ${props => maxSize(863, props.styleType, 'height', 617)};
    position: relative;
    background-color: #F8F5F1;
`;

export const MenuClose = styled('div')`
    position: absolute;
    cursor: pointer;
    ${props => maxSize(38, props.styleType, 'width', 20)};
    ${props => maxSize(38, props.styleType, 'height', 20)};
    ${props => maxSize(54, props.styleType, 'top', 32)};
    ${props => maxSize(70, props.styleType, 'left', 227)};
    transform: rotate(45deg);
    & #left {
        border-top: 1px solid black;
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
    }
    & #right {
        border-left: 1px solid black;
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
    }
`;

export const MenuTitle = styled('div')`
    position: absolute;
    font-weight: 100;
    cursor: pointer;
    ${props => maxSize(36, props.styleType, 'font-size', 20)};
    ${props => maxSize(123, props.styleType, 'left', 32)};
    ${props => `line-height: ${props.styleType === STYLE_TYPE.MOBILE ? px2vw(40, 375) : 'auto'}`};
    ${props => maxSize(props.top, props.styleType, 'top', props.mobileTop)};
    text-decoration: none;
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                ${maxSize(215, props.styleType, 'max-width')}
                overflow: hidden;
                text-overflow: ellipsis;
            `
        }
    }}

`;

export const MenuSubTitle = styled('div')`
    color: ${themeColor};
    position: absolute;
    text-decoration: none;
    cursor: pointer;
    ${props => maxSize(14, props.styleType, 'font-size',12)};
    ${props => maxSize(props.left || 123, props.styleType, 'left', props.mobileLeft || 32)};
    ${props => maxSize(props.top, props.styleType, 'top', props.mobileTop)};
`;

export const SubTitleWrapper = styled('div')`
    ${props => maxSize(105, props.styleType, 'height', 92)};
    border-left: 1px solid #DFDCD8;
    position: absolute;
    width: 0px;
    ${props => maxSize(130, props.styleType, 'left', 36)};
    ${props => maxSize(330, props.styleType, 'top', 233)};
`;

export const MenuArrow = styled('div')`
    position: absolute;
    ${props => maxSize(510, props.styleType, 'left', 163)};
    ${props => maxSize(629, props.styleType, 'top', 565)};
    display: flex;
    justify-content: center;
    align-items: center;
    & span {
        font-weight: 600;
        ${props => maxSize(18, props.styleType, 'font-size', 14)};
        ${props => maxSize(18, props.styleType, 'height', 14)};
    }
    & img {
        ${props => maxSize(17, props.styleType, 'height', 17)};
        ${props => maxSize(17, props.styleType, 'width', 17)};
        ${props => maxSize(14, props.styleType, 'margin-left', 8)};
    }
`;

export const Background = styled('div')`
    width: 100%;
    height: 100%;
    background:  rgba(0, 0, 0, 0.45);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
`;

export const Title = styled('pre')`
${props => maxSize(36, props.styleType, 'font-size', 18)};
${props => maxSize(1000, props.styleType, 'width', 200)};
white-space: pre-wrap;
position: absolute;
left: 50%;
top: 50%;
transform: translate(-50%, -50%);
text-align: center;
color: white;
z-index: 2;
margin: 0;
${props => {
    if(props.styleType === STYLE_TYPE.MOBILE) {
        return 'letter-spacing: 0.1em;';
    } else {
        return 'letter-spacing: 0.4em;';
    }

}}
`;